import { render } from "./ProductFilters.vue?vue&type=template&id=5667dc05&scoped=true"
import script from "./ProductFilters.vue?vue&type=script&lang=js"
export * from "./ProductFilters.vue?vue&type=script&lang=js"

import "./ProductFilters.vue?vue&type=style&index=0&id=5667dc05&scoped=true&lang=css"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5667dc05"]])

export default __exports__